import {
  and,
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Failure from '../../../core/Failure';
import Job from '../../models/Job';
import { IContact } from '@leedpulse-monorepo/interfaces';
import { JobType } from '@leedpulse-monorepo/enums';

async function getContactNextJob(contact: IContact): Promise<Job | null> {
  try {
    const db = firestore;
    const jobsCollection = collection(db, FirestoreCollections.jobs);

    const jobDocRef = await getDocs(
      query(
        jobsCollection,
        and(
          where('id_contact', '==', contact.id),
          where('id_api_key', '==', contact.id_api_key),
          // Its workflow jobs are not SMS (index Jobs: id_api_key, id_contact, timestamp, type)
          where('type', '!=', JobType.workflow)
        ),
        orderBy('timestamp', 'asc'),
        limit(1)
      )
    );

    const jobs: Job[] = [];
    jobDocRef.docs.forEach((doc) => {
      jobs.push(doc.data() as Job);
    });

    if (jobs.length === 0) {
      return null;
    }

    return jobs[0];
  } catch (e) {
    console.log('error: ', e);
    throw new GetContactNextJobFailure();
  }
}

export class GetContactNextJobFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getContactNextJob;
